(function() {
    'use strict';

    angular.module('itxApp.catalog', [
            'itxApp.common',
            'infinite-scroll'
        ]);
 
})();